import dayjs from 'dayjs';
import { IBooking, IStatusUpdate } from '../interfaces/booking.interface';
import { FINISHED, ON_HOLD, STATUSES } from '../const/booking.constants';

export const diffTimeInMinutes = (t1: string | Date, t2?: string | Date | null): number => {
    const d1 = new Date(t1).getTime();
    const d2 = t2 ? new Date(t2).getTime() : Date.now();
    return Math.round((d2 - d1) / 60000);
};

export const diffTimeInSeconds = (t1: string | Date, t2?: string | Date | null): number => {
    const d1 = new Date(t1).getTime();
    const d2 = t2 ? new Date(t2).getTime() : Date.now();
    return Math.max(0, Math.ceil((d2 - d1) / 1000) % 60);
};

export const getMinutes = ({
    statusText,
    bookingCompletionDateTime,
    createdAt,
    cookTime,
    statusUpdates,
}: IBooking): number => {
    let end: string | Date | null | undefined;

    if (statusText === STATUSES.COMPLETED && bookingCompletionDateTime) {
        end = bookingCompletionDateTime;
    } else if (FINISHED.includes(statusText)) {
        const lastStatus = statusUpdates ? statusUpdates[statusUpdates.length - 1] : null;
        end = lastStatus ? lastStatus.timeStamp : null;
    } else if (ON_HOLD.includes(statusText)) {
        end = dayjs(createdAt).add((cookTime || 0) / 60000, 'minute').toISOString();
        return diffTimeInMinutes(new Date().toISOString(), end);
    } else if (statusText === STATUSES.READY_FOR_PICKUP && statusUpdates) {
        const previousStatus = statusUpdates[0]?.previousStatusText;
        if (previousStatus === STATUSES.ON_HOLD) {
            end = statusUpdates[0]?.timeStamp;
            return diffTimeInMinutes(end as string | Date, new Date());
        }
    } else {
        end = bookingCompletionDateTime;
    }
    return diffTimeInMinutes(createdAt, end);
};

export const getSeconds = ({
    statusText,
    bookingCompletionDateTime,
    updatedAt,
    createdAt,
    cookTime,
}: IBooking): number => {
    let end: string | Date | null | undefined;
    if (
        (statusText === STATUSES.COMPLETED && !bookingCompletionDateTime)
        || FINISHED.includes(statusText)
    ) {
        end = updatedAt;
    } else if (ON_HOLD.includes(statusText)) {
        end = dayjs(createdAt).add((cookTime || 0) / 60000, 'minute').toISOString();
        return diffTimeInSeconds(new Date().toISOString(), end);
    } else {
        end = bookingCompletionDateTime;
    }
    return diffTimeInSeconds(createdAt, end);
};

export const formatPhone = (phone: string, provider: string): string => {
    switch (provider) {
    case 'MENSAJEROS_URBANOS':
        return `+52${phone}`;
    default:
        return phone;
    }
};

export const getETA = (
    estimatedTimeToPointA: number,
    estimatedTimeToPointB: number,
    statusUpdates: IStatusUpdate[],
    isPicking: boolean,
    isDelivering: boolean,
): number => {
    const { ACCEPTED, WAY_TO_DELIVER } = STATUSES;
    let status: IStatusUpdate[];
    let ETA: string | undefined;
    if (estimatedTimeToPointA && estimatedTimeToPointB) {
        if (isPicking) {
            status = statusUpdates.filter((statusUpdate: IStatusUpdate) => {
                const { newStatusText } = statusUpdate;
                return newStatusText === ACCEPTED;
            });
            if (status.length === 0) {
                return 0;
            }
            const { timeStamp } = status[status.length - 1];
            ETA = timeStamp ? dayjs(timeStamp).add(estimatedTimeToPointA, 'minute').toISOString() : undefined;
        } else if (isDelivering) {
            status = statusUpdates.filter((statusUpdate: IStatusUpdate) => {
                const { newStatusText } = statusUpdate;
                return newStatusText === WAY_TO_DELIVER;
            });
            if (status.length === 0) {
                return 0;
            }
            const { timeStamp } = status[status.length - 1];
            ETA = timeStamp ? dayjs(timeStamp).add(estimatedTimeToPointB, 'minute').toISOString() : undefined;
        }
        if (ETA && dayjs(ETA).isBefore(dayjs())) {
            ETA = dayjs().add(2, 'minute').toISOString();
        }
        const diffMinutes = Math.ceil(dayjs(ETA).diff(dayjs()) / 60000);
        return Number((diffMinutes / 60).toFixed(0));
    }
    return 0;
};
